import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";

import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import EditPolicyList from "./EditPolicyList";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import moment from "moment";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  CloudOffIcon,
  DownloadIcon,
  EditIcon,
  AddIcon,
  DeleteIcon,
} from "../../../Resources/Icons/icons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FileUploader } from "react-drag-drop-files";
import {
  AWS_DIRECTORY_NAME,
  PolicyFilterTypes,
  CancelledPolicyFilterType,
  FilterOption,
  checkUserType,
} from "../../../Shared/CommonConstant";
import CancelPolicyDialog from "../CancelPolicyDialog/CancelPolicyDialog";
import Loader from "../../../UiComponents/Loader/Loader";
import {
  GetPolicyFileById,
  GetCompany,
  GetPolicyList,
  GetProduct,
  FilterPolicyList,
  UpdatePolicyList,
  GetPolicyFindbyId,
  DeletePolicyList,
  ReframeEndDateTimeFormat,
} from "../../../Service/_index";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { DatePicker } from "antd";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CloseIcon from "@mui/icons-material/Close";
import wallett from "../../../Resources/Images/wallet.png";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import CloudDoneIcon from "@mui/icons-material/CloudDone";


const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
const getClassName = (data) => {
  return data.policyNumber ? "file_link" : "";
};

const headCells = [
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registrationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product",
  },
  // Changes by Arun
  {
    id: "paymentMode",
    placeMent: true,
    disablePadding: false,
    label: "Payment Mode",
  },
  // {
  //   id: "odPremium",
  //   placeMent: true,
  //   disablePadding: false,
  //   label: "OD Pre",
  // },
  {
    id: "netPremium",
    placeMent: true,
    disablePadding: false,
    label: "Net Pre",
    format: "integer",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Total Pre",
    format: "integer",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
  {
    id: "policyStatus",
    placeMent: true,
    disablePadding: false,
    label: "Policy Status",
    type: "button",
    buttonLabel: "Entry Pending",
    buttonColor: "success",
    buttonClass: "Dynamic_Button",
  },
  {
    id: "policyFileStatus",
    placeMent: true,
    disablePadding: false,
    label: "Policy File",
    type: "component",
    // getColor: (row) => {
    //   return row.policyFileStatus === "Uploaded" ? "green" : "red";
    // },
    renderComponent: (row) => {
      const isUploaded = row.policyFileStatus === "Uploaded";
      return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isUploaded ? (
            <CloudDoneIcon sx={{ color: "#10B981", fontSize: "20px" }} />
          ) : (
            <CloudOffIcon sx={{ color: "#EF4444", fontSize: "20px" }} />
          )}
        </Box>
      );
    },
  }
];

const RejectedCells = [
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
  {
    id: "policyStatus",
    placeMent: true,
    disablePadding: false,
    label: "Policy Status",
  },
  {
    id: "rejectedReason",
    placeMent: true,
    disablePadding: false,
    label: "Rejected Reason",
  },
];
function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, rejectedPolicy } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const celltoMap = rejectedPolicy ? RejectedCells : headCells;

  return (
    <TableHead>
      <TableRow>
        {celltoMap?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const PolicyList = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState({});
  const [openCancelPolicyDialog, setOpenCancelPolicyDialog] = useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [openEditPolictDrawer, setOpenEditPolicyDrawer] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedComapny, setSelectedCompany] = useState(null);
  const [selectedproduct, setSelectedProduct] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedPolicyFileStatus, setSelectedPolicyFileStatus] =
    useState(null);
  const [openUploadFileBox, setOpenUploadFileBox] = useState(false);
  const [uploadFiles, setUploadFiles] = useState({});
  const [policyCount, setPolicyCount] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [editType, setEditType] = useState();
  const [isEditRejectPopup, setIsEditRejectPopup] = useState(false);
  const [rejectedPolicyNumber, setRejectdPolicyNumber] = useState(null);
  const [showRejectedPolicyTable, setShowRejectedPolicyTable] = useState(false);
  const [formType, setFormType] = useState();
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [fileTitle, setFileTitle] = useState({});
  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isView: policyList.some((policy) => policy.status !== "rejectedPolicy")
      ? true
      : false,
    isEdit: true,
    // isDelete: policyList.some((policy) => policy.status !== "rejectedPolicy")
    //   ? true
    //   : false,
    isDelete: false,
    isSearch: true,
    isUpload: true,
    isFileDownload: true,
    isApprove: false,
    isCancel: true, // the icon only shows on approved rows, for the admin login
  });
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const visibleRows = React.useMemo(
    () =>
      stableSort(
        filter.fn(
          policyList.map((e) => ({
            ...e,
            companyName: e.companyId?.shortName,
          }))
        ),
        getComparator(order, orderBy)
      )?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage, filter, policyList]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getLabelForValue = (value) => {
    const option = [...PolicyFilterTypes, CancelledPolicyFilterType].find(
      (option) => option.value === value
    );
    return option ? option.label : null;
  };
  const UserType = sessionStorage.getItem("userType");
  const handleCancel = (row) => {
    setSelectedData(row);
    setOpenCancelPolicyDialog(true);
  };

  const [isAllow, setIsAllow] = useState({});

  React.useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, []);

  const GetData = () => {
    setOpenLoader(true);
    GetPolicyList()
      .then((res) => {
        setOpenLoader(false);
        // console.log(UserType);
        if (res && res.data && Array.isArray(res.data)) {
          const FilteredData = res.data.filter(
            (item) =>
              item.status ===
              (UserType === FilterOption[1]?.value
                ? PolicyFilterTypes[2]?.value
                : PolicyFilterTypes[2]?.value)
          );
          const totalPremiumValues = FilteredData.map((e) => e.totalPremium);
          setPolicyList(FilteredData);
          setPolicyCount(totalPremiumValues);
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error fetching policy list:", error);
        ToastError("Failed to fetch policy list. Please try again.");
      });
  };

  const FilteredData = policyList.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const policyListDetails =
      `${el?.companyName},${el?.paymentMode},${el?.email},${el?.customerName},${el?.registrationNumber},${el?.policyNumber}`.toLowerCase();
    return policyListDetails.includes(searchTerm);
  });

  const EditPolicyListData = (row, value) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id)
      .then((res) => {
        setOpenLoader(false);
        if (res && res.data) {
          setOpenEditPolicyDrawer(true);
          setSelectedData(res.data);
          // setEditType(value);
          console.log("filterrrrrr type", PolicyFilterTypes[2].value)
          console.log('filterrrrrrr', PolicyFilterTypes[1].value)
          setEditType(
            value === "EntryPendingButton"
              ? "EntryPendingButton"
              : value === "VerifyPendingButton"
                ? "VerifyPendingButton"
                : row.status === PolicyFilterTypes[1]?.value ||
                  row.status === PolicyFilterTypes[2]?.value
                  ? "EntryPending"
                  : "CommonEdit"
          );

          setFormType("edit");
        } else {
          ToastError("Failed to fetch policy data.");
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error fetching policy data:", error);
        ToastError("Failed to fetch policy data. Please try again.");
      });
  };

  const EditRejectedPolicyData = (row) => {
    setIsEditRejectPopup(true);
    setSelectedData(row);
  };

  const EditRejectedPolicyFunction = () => {
    setOpenLoader(true);
    const data = {};
    data.policyNumber = rejectedPolicyNumber;
    data.status = PolicyFilterTypes[1]?.value;
    data.rejectedReason = "";
    UpdatePolicyList(selectedData?._id, data)
      .then(() => {
        setOpenLoader(false);
        setIsEditRejectPopup(false);
        UniversalSearch(false);
        ToastSuccess("Retrived Succesfully");
      })
      .catch((err) => {
        setOpenLoader(false);
        ToastError("NetWork Error");
      });
  };

  const OpenPolicyFile = (row) => {
    if (openLoader) {
      return;
    }

    if (!row?._id) {
      ToastError("Policy ID not found.");
      return;
    }

    // Mobile browsers (iOS Safari, Android Chrome) block window.open() unless it
    // runs synchronously inside the user's tap. Open the tab now, show a
    // placeholder, and navigate it to the PDF once the URL arrives.
    let pdfWindow = null;
    try {
      pdfWindow = window.open("", "_blank");
      if (pdfWindow) {
        pdfWindow.document.write(
          "<html><head><title>Policy PDF</title></head><body style=\"font-family:sans-serif;padding:24px;\">Loading policy PDF...</body></html>"
        );
      }
    } catch (e) {
      pdfWindow = null;
    }

    const closePdfWindow = () => {
      try {
        if (pdfWindow && !pdfWindow.closed) {
          pdfWindow.close();
        }
      } catch (e) {
        // ignore
      }
    };

    const showPdf = (url) => {
      if (pdfWindow && !pdfWindow.closed) {
        // Navigating to the URL lets the browser use its native PDF viewer,
        // which works on mobile where <embed> does not render.
        pdfWindow.location.href = url;
      } else {
        // Popup was blocked: open in the current tab as a fallback.
        window.location.assign(url);
      }
    };

    setOpenLoader(true);
    GetPolicyFileById(row._id)
      .then((res) => {
        setOpenLoader(false);

        // Check if response exists
        if (!res) {
          closePdfWindow();
          ToastError("Failed to fetch PDF file. No response received.");
          return;
        }

        // Check if response has error
        if (res.error) {
          closePdfWindow();
          ToastError(res.message || "Failed to fetch PDF file.");
          return;
        }

        // The service returns response.data, which could be { data: {...} } or direct object
        // Try both structures: res.data.policyFile or res.policyFile
        const policyData = res.data || res;

        if (!policyData) {
          closePdfWindow();
          ToastError("PDF file data not found.");
          return;
        }

        const pdfUrl = policyData?.policyFile?.downloadURL;

        if (!pdfUrl) {
          closePdfWindow();
          ToastError("PDF file URL not found.");
          return;
        }

        // Check if pdfUrl is already a URL (signed URL from S3) or base64 string
        const isUrl =
          typeof pdfUrl === "string" &&
          (pdfUrl.startsWith("http://") || pdfUrl.startsWith("https://"));

        if (isUrl) {
          // If it's already a URL, use it directly
          showPdf(pdfUrl);
        } else {
          // If it's base64, convert to blob
          try {
            const blobData = base64toBlob(pdfUrl, "application/pdf");
            const blobUrl = URL.createObjectURL(blobData);
            showPdf(blobUrl);
          } catch (error) {
            closePdfWindow();
            console.error("Error converting base64 to blob:", error);
            ToastError("Failed to display PDF. Invalid file format.");
          }
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        closePdfWindow();
        console.error("Error fetching PDF:", error);
        ToastError("Failed to fetch PDF file. Please try again.");
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const ViewPolicyFunction = (row) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id)
      .then((res) => {
        setOpenLoader(false);
        if (res && res.data) {
          setOpenEditPolicyDrawer(true);
          setSelectedData(res.data);
          setFormType("view");
        } else {
          ToastError("Failed to fetch policy data.");
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error fetching policy data:", error);
        ToastError("Failed to fetch policy data. Please try again.");
      });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.companyId?.companyName},${el?.policyNumber},${el?.customerName
              },${el?.registrationNumber},${el?.productId?.product},${el?.paymentMode
              }, ${el?.odPremium},${el?.netPremium},${el?.totalPremium},${el?.userId?.email
              },${el?.status},${moment(el.issueDate).format("D-M-Y")}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true })
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          const modifiedCompanyDetails = res.data
            .map((e) => {
              if (e.isEnabled) {
                return {
                  ...e,
                  label: e.shortName,
                  value: e._id,
                };
              } else {
                return null;
              }
            })
            .filter(Boolean);
          setCompanyDetails(modifiedCompanyDetails);
        }
      })
      .catch((error) => {
        console.error("Error fetching company details:", error);
      });
  };

  const GetProductDetails = () => {
    GetProduct({ isAscending: true })
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          const modifiedproduct = res.data
            .map((e) => {
              if (e.isEnabled) {
                return {
                  ...e,
                  label: e.product,
                  value: e._id,
                };
              } else {
                return null;
              }
            })
            .filter(Boolean);
          setProductDetails(modifiedproduct);
        }
      })
      .catch((error) => {
        console.error("Error fetching product details:", error);
      });
  };

  // const calculateSum = (arr) => {
  //   return arr?.reduce((total, current) => {
  //     return Number(total) + Number(current);
  //   }, 0);
  // };

  const calculateSum = (arr) => {
    return arr?.reduce((total, current) => {
      return Number(total) + Number(current);
    }, 0);
  };

  // Function to format the number
  // const formatNumber = (number) => {
  //   const formattedNumber = new Intl.NumberFormat("en-IN").format(number); // Format with Indian commas
  //   return `${formattedNumber}`; // Add .00 for decimal
  // };

  const formatNumber = (num) => new Intl.NumberFormat("en-IN").format(num);

  const sum = calculateSum(policyCount);

  const UniversalSearch = async (isButtonClick, overrides = {}) => {
    const currentStartDate = overrides.hasOwnProperty("startDate")
      ? overrides.startDate
      : selectedStartDate;
    const currentEndDate = overrides.hasOwnProperty("endDate")
      ? overrides.endDate
      : selectedEndDate;

    // const selectedStartDate = dateRange[0];
    // const selectedEndDate = dateRange[1];
    // Changes by Arun
    if (!selectedStatus && isButtonClick) {
      ToastError("Please select policy types filter");
      return true;
    }

    // Changes by Arun
    if (
      (selectedStatus == PolicyFilterTypes[0]?.value ||
        selectedStatus == PolicyFilterTypes[4]?.value) &&
      isButtonClick &&
      (!currentStartDate || !currentEndDate)
    ) {
      ToastError("Please select date range");
      return true;
    }
    // console.log("selectedStatus ", selectedStatus);

    setOpenLoader(true);
    // Changes by Arun
    // let endDate = null;
    // if (selectedEndDate) {
    //   endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    // }
    FilterPolicyList({
      companyId: selectedComapny?._id || selectedComapny,
      productId: selectedproduct?._id || selectedproduct,
      startDate: currentStartDate,
      endDate: currentEndDate,
      status: selectedStatus,
      policyFileStatus: selectedPolicyFileStatus,
    })
      .then((res) => {
        setOpenLoader(false);
        if (res && res.data && Array.isArray(res.data)) {
          const updatedData = res.data.map((e) => ({
            ...e,
            policyDate: moment(e.issueDate).format("DD/MM/YYYY"),
            companyName: e?.companyId?.shortName,
            email: e?.userId?.email,
            policyStatus: e?.status,
            product: e?.productId?.product,
            formatStatus:
              e?.status === "rejectedPolicy"
                ? "Rejected Policy"
                : e?.status === "cancelled"
                  ? "Cancelled"
                  : "approvePending"
                    ? "Approved"
                    : "chequePending"
                      ? "Cheque Pending"
                      : e?.status,
            policyFileStatus:
              e.policyFile && Object.keys(e.policyFile).length > 0
                ? "Uploaded"
                : "Not Uploaded",
          }));
          setPolicyList(updatedData);
          setShowRejectedPolicyTable(
            selectedStatus === PolicyFilterTypes[6]?.value ? true : false
          );
          const totalPremiumValues = res.data.map((e) => e.totalPremium);
          setPolicyCount(totalPremiumValues);
          setPage(0);
        } else {
          setPolicyList([]);
          setPolicyCount([]);
          setPage(0);
        }
      })
      .catch((err) => {
        setOpenLoader(false);
        console.error("Error filtering policy list:", err);
        ToastError("Failed to filter policy list. Please try again.");
      });
  };

  React.useEffect(() => {
    GetCompanyDetails();
    GetProductDetails();
    // GetData();
  }, []);
  const TriggerUploadFilesFunction = () => {
    setOpenUploadFileBox(true);
  };
  const UploadFilesFunction = () => {
    let formData = new FormData();
    for (var key in uploadFiles) {
      formData.append(key, uploadFiles[key]);
    }
    formData.append(
      AWS_DIRECTORY_NAME.AWS_POLICY_FILE_DIRECTORY_NAME,
      uploadFiles.policyFile
    );
    formData.append(
      AWS_DIRECTORY_NAME.AWS_OTHER_FILE_DIRECTORY_NAME,
      uploadFiles.otherFile
    );
    UpdatePolicyList(selectedData?._id, formData)
      .then((res) => {
        setOpenUploadFileBox(false);
        setUploadFiles({});
        setFileTitle(null);
      })
      .catch((err) => {
        console.log(err);
        ToastError("Something Went error");
        setOpenUploadFileBox(false);
        setFileTitle(null);
      });
  };

  // const isRemoveFields = [
  //   PolicyFilterTypes[1].value,
  //   PolicyFilterTypes[2].value,
  //   PolicyFilterTypes[3].value,
  //   PolicyFilterTypes[4].value,
  //   PolicyFilterTypes[5].value,
  // ];

  // Changed by Arun
  // PT staff role - Display entry pending option only
  const isRemoveFields =
    UserType === FilterOption[4]?.value
      ? [PolicyFilterTypes[1]?.value]
      : [
        PolicyFilterTypes[1]?.value,
        PolicyFilterTypes[2]?.value,
        PolicyFilterTypes[3]?.value,
        PolicyFilterTypes[4]?.value,
        PolicyFilterTypes[5]?.value,
      ];
  console.log("isRemoveFields ", isRemoveFields);
  // End of changes

  const UserFilterOption = PolicyFilterTypes.filter((item) =>
    isRemoveFields.includes(item.value)
  );
  // "Cancelled Policy" is offered to the admin-type logins only (it is not part of PolicyFilterTypes: other pages read that by position)
  const canSeeCancelled = ["CLIENT", "accountant"].includes(UserType);
  const PolicyFilterOption =
    UserType === FilterOption[3].value || UserType === FilterOption[4].value
      ? UserFilterOption
      : canSeeCancelled
        ? [...PolicyFilterTypes, CancelledPolicyFilterType]
        : PolicyFilterTypes;
  const DownloadFileFunction = (row) => {
    if (openLoader) {
      return;
    }

    if (!row?._id) {
      ToastError("Policy ID not found.");
      return;
    }

    setOpenLoader(true);
    GetPolicyFileById(row._id)
      .then((res) => {
        setOpenLoader(false);

        // Check if response exists
        if (!res) {
          ToastError("Failed to fetch PDF file. No response received.");
          return;
        }

        // Check if response has error
        if (res.error) {
          ToastError(res.message || "Failed to fetch PDF file.");
          return;
        }

        // The service returns response.data, which could be { data: {...} } or direct object
        // Try both structures: res.data.policyFile or res.policyFile
        const policyData = res.data || res;

        if (!policyData) {
          ToastError("PDF file data not found.");
          return;
        }

        const pdfUrl = policyData?.policyFile?.downloadURL;

        if (!pdfUrl) {
          ToastError("PDF file URL not found.");
          return;
        }

        // Check if pdfUrl is already a URL (signed URL from S3) or base64 string
        const isUrl =
          typeof pdfUrl === "string" &&
          (pdfUrl.startsWith("http://") || pdfUrl.startsWith("https://"));

        if (isUrl) {
          // If it's already a URL, download directly
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.download = "downloaded_pdf.pdf";
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // If it's base64, convert to blob and download
          try {
            const blobData = base64toBlob(pdfUrl, "application/pdf");
            const blobUrl = URL.createObjectURL(blobData);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = "downloaded_pdf.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Clean up the blob URL
            URL.revokeObjectURL(blobUrl);
          } catch (error) {
            console.error("Error converting base64 to blob:", error);
            ToastError("Failed to download PDF. Invalid file format.");
          }
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.error("Error fetching PDF:", error);
        ToastError("Failed to fetch PDF file. Please try again.");
      });
  };

  const DeletePolicyData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    DeletePolicyList(selectedData._id).then(() => {
      UniversalSearch(false);
    });
    setOpenDeleteConfirmBox(false);
  };

  const implementCond = (cell) => {
    // Filter out policyNumber column for PT staff
    const filteredCells = UserType === "ptstaff"
      ? cell.filter((obj) => obj.id !== "policyNumber")
      : cell;

    return filteredCells.map((obj) =>
      obj.id === "policyStatus"
        ? {
          ...obj,
          condition: (row) =>
            ["entryPending", "verifyPending", "chequePending"].includes(
              row?.policyStatus
            ),
          fallbackText: (row) => row?.formatStatus,
          newLabel: (row) => {
            switch (row?.policyStatus) {
              case "entryPending":
                return "Entry Pending";
              case "verifyPending":
                return "Verify Pending";
              case "approvePending":
                return "Approved";
              case "approvedPolicy":
                return "Approved";
              case "chequePending":
                return "Cheque";
              // case "rejectedPolicy":
              //   return "Rejected";
              default:
                return undefined;
            }
          },
          behaviour: (row) => {
            switch (row?.policyStatus) {
              case "entryPending":
                return (row) => EditPolicyListData(row, "EntryPendingButton");
              case "verifyPending":
                return (row) => EditPolicyListData(row, "VerifyPendingButton");
              case "approvePending":
              // return EditPolicyListData;
              case "chequePending":
              // return EditPolicyListData;
              case "approvedPolicy":
              // return EditPolicyListData;
              // case "rejectedPolicy":
              // return EditPolicyListData;
              default:
                return null;
            }
          },
        }
        : obj
    );
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleClearAllState = () => {
    setSelectedStatus(null);
    // onHandleCompanyChange(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setSelectedCompany(null);
    setSelectedProduct(null);
    setSelectedPolicyFileStatus(null);
    setSearchTrigger((prev) => prev + 1);
  };

  const handleClearSingleFilter = (filterId) => {
    // Calculate updated filter values based on which filter is being cleared
    const updatedStatus = filterId === 1 ? null : selectedStatus;
    const updatedCompany = filterId === 2 ? null : selectedComapny;
    const updatedProduct = filterId === 3 ? null : selectedproduct;
    const updatedStartDate = filterId === 4 ? null : selectedStartDate;
    const updatedEndDate = filterId === 4 ? null : selectedEndDate;
    const updatedPolicyFileStatus =
      filterId === 6 ? null : selectedPolicyFileStatus;

    // Clear the specific filter based on ID
    if (filterId === 1) {
      setSelectedStatus(null);
    } else if (filterId === 2) {
      setSelectedCompany(null);
    } else if (filterId === 3) {
      setSelectedProduct(null);
    } else if (filterId === 4) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    } else if (filterId === 6) {
      setSelectedPolicyFileStatus(null);
    }

    // Call API directly with updated values (no need to wait for state update)
    setOpenLoader(true);
    FilterPolicyList({
      companyId: updatedCompany?._id || updatedCompany,
      productId: updatedProduct?._id || updatedProduct,
      startDate: updatedStartDate,
      endDate: updatedEndDate,
      status: updatedStatus,
      policyFileStatus: updatedPolicyFileStatus,
    })
      .then((res) => {
        setOpenLoader(false);
        if (res && res.data && Array.isArray(res.data)) {
          const updatedData = res.data.map((e) => ({
            ...e,
            policyDate: moment(e.issueDate).format("DD/MM/YYYY"),
            companyName: e?.companyId?.shortName,
            email: e?.userId?.email,
            policyStatus: e?.status,
            product: e?.productId?.product,
            formatStatus:
              e?.status === "rejectedPolicy"
                ? "Rejected Policy"
                : e?.status === "cancelled"
                  ? "Cancelled"
                  : "approvePending"
                    ? "Approved"
                    : "chequePending"
                      ? "Cheque Pending"
                      : e?.status,
            policyFileStatus:
              e.policyFile && Object.keys(e.policyFile).length > 0
                ? "Uploaded"
                : "Not Uploaded",
          }));
          setPolicyList(updatedData);
          setShowRejectedPolicyTable(
            updatedStatus === PolicyFilterTypes[6]?.value ? true : false
          );
          const totalPremiumValues = res.data.map((e) => e.totalPremium);
          setPolicyCount(totalPremiumValues);
          setPage(0);
        } else {
          setPolicyList([]);
          setPolicyCount([]);
          setPage(0);
        }
      })
      .catch((err) => {
        setOpenLoader(false);
        console.error("Error filtering policy list:", err);
        ToastError("Failed to filter policy list. Please try again.");
      });
  };

  const handleSaveAllFilter = () => {
    // GetFilterCompanyLoginData();
    // UniversalSearch();
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      UniversalSearch(true);
    }
  }, [searchTrigger]);

  const filterBoxData = [
    {
      id: 1,
      label: "Policy Type",
      data: PolicyFilterOption,
      setState: (e) => {
        let option = PolicyFilterOption.find((el) => el._id === e);
        if (option) {
          setSelectedStatus(option.value);
        }
      },
      value: PolicyFilterOption.find((opt) => opt.value === selectedStatus)
        ?._id,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedComapny,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select Product",
      data: productDetails,
      setState: setSelectedProduct,
      value: selectedproduct,
      type: "input",
      variation: "single",
    },
    {
      id: 4,
      label: "Start Date & End Date",
      setDate: (e) => {
        const newStartDate = e ? e[0] : null;
        const newEndDate = e ? e[1] : null;
        setSelectedStartDate(newStartDate);
        setSelectedEndDate(newEndDate);
        UniversalSearch(false, {
          startDate: newStartDate,
          endDate: newEndDate,
        });
      },
      type: "noDefaultDate",
    },
    {
      id: 6,
      label: "Policy File Status",
      data: [
        { _id: "uploaded", label: "Uploaded", value: "uploaded" },
        { _id: "notUploaded", label: "Not Uploaded", value: "notUploaded" },
      ],
      setState: (e) => {
        if (e === "uploaded") {
          setSelectedPolicyFileStatus("uploaded");
        } else if (e === "notUploaded") {
          setSelectedPolicyFileStatus("notUploaded");
        }
      },
      value: selectedPolicyFileStatus,
      type: "input",
      variation: "single",
    },
  ];

  const activeFiltersCount =
    [selectedStatus, selectedComapny, selectedproduct].filter(Boolean).length +
    (selectedStartDate && selectedEndDate ? 1 : 0);

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Policy List
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          color="error"
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{ margin: "0px 10px" }}
              // className="Master_Card_Sub_Container"
              >
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={3.1}
                  mt={{ xs: 2, sm: 0, md: 0 }}
                  sx={{ display: "flex" }}
                >
                  <Grid
                    item
                    marginLeft={2}
                    margin={1}
                    sx={{
                      backgroundColor: "#F0F5FA",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      padding: "2px",
                      paddingRight: "15px",
                      paddingLeft: "15px",
                      gap: "10px",
                      border: "1px solid #DFE7F1",
                    }}
                  >
                    <Grid>
                      <img src={wallett} width="18px" height="17px" />
                    </Grid>
                    <Grid>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#1E3A5F",
                          fontSize: 16,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {/* {formatNumber(sum)} */}
                        {formatNumber(policyList?.length || 0)}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#667085",
                          fontSize: 12,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        Policy Count{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    marginLeft={2}
                    margin={1}
                    sx={{
                      backgroundColor: "#F0F5FA",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      padding: "2px",
                      paddingRight: "15px",
                      paddingLeft: "15px",
                      gap: "10px",
                      border: "1px solid #DFE7F1",
                    }}
                  >
                    <Grid>
                      <img src={wallett} width="18px" height="17px" />
                    </Grid>
                    <Grid>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#1E3A5F",
                          fontSize: 16,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {/* ₹ {calculateSum(policyCount)}{" "} */}₹{" "}
                        {formatNumber(sum) || 0}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#667085",
                          fontSize: 12,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        Total Wallet
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search User"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                // columns={headCells}
                columns={implementCond(
                  policyList.some(
                    (policy) => policy.status !== "rejectedPolicy"
                  )
                    ? headCells
                    : RejectedCells
                )}
                // isServerSide={true}
                handleOnClickBehaviour={OpenPolicyFile}
                handleView={ViewPolicyFunction}
                handleEdit={
                  policyList.some(
                    (policy) => policy.status !== "rejectedPolicy"
                  )
                    ? EditPolicyListData
                    : EditRejectedPolicyData
                }
                handleDelete={DeletePolicyData}
                handleCancel={handleCancel}
                handleDownload={DownloadFileFunction}
                handleUpload={TriggerUploadFilesFunction}
                handleButton={{
                  "Entry Pending": (row) => EditPolicyListData(row, "EntryPendingButton"),
                }}
                // handleButton2={handleButton}
                tableTotalCount={filter.fn(policyList)?.length || 0}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Drawer
        open={openEditPolictDrawer}
        sx={{ zIndex: 100 }}
        anchor="right"
        PaperProps={{ sx: { width: { xs: "100%", sm: "100%" } } }}
      >
        {openEditPolictDrawer ? (
          <EditPolicyList
            editType={editType}
            GetData={UniversalSearch}
            setOpenEditPolicyDrawer={setOpenEditPolicyDrawer}
            openEditPolictDrawer={openEditPolictDrawer}
            selectedData={selectedData}
            formType={formType}
          />
        ) : null}
      </Drawer>
      <CancelPolicyDialog
        open={openCancelPolicyDialog}
        onClose={() => setOpenCancelPolicyDialog(false)}
        policy={selectedData}
        onCancelled={() => UniversalSearch(false)}
      />
      <div>
        <Dialog
          open={openUploadFileBox}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="DrawerContainer">
            <Grid
              container
              className="DrawerHeader"
              sx={{ marginBottom: "0px !important" }}
            >
              <Grid item xs={6} sm={6}>
                <Typography>Upload Policy Documents</Typography>
              </Grid>
              <Grid item xs={6} sm={6} className="d-flex justify-content-end">
                <CloseIcon
                  onClick={() => setOpenUploadFileBox(false)}
                  sx={{
                    cursor: "pointer",
                    height: "18px",
                    width: "18px",
                    fontWeight: 600,
                  }}
                />
              </Grid>
            </Grid>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Grid container rowGap={1}>
                  <Grid item className="File-Upload" xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        mb: 1,
                        color: "black",
                        fontWeight: 400,
                        paddingBottom: "4px",
                      }}
                    >
                      Policy File
                    </Typography>{" "}
                    <FileUploader
                      name="OtherFile"
                      label="Upload Your Policy File"
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                      handleChange={(e) => {
                        setFileTitle({ ...fileTitle, policyFile: e.name });
                        setUploadFiles({ ...uploadFiles, policyFile: e });
                      }}
                    />
                  </Grid>
                  <div className="fileTitle">
                    {fileTitle?.policyFile ? fileTitle?.policyFile : null}
                  </div>
                  <Grid item className="File-Upload" xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        mb: 1,
                        color: "black",
                        fontWeight: 400,
                        paddingBottom: "4px",
                      }}
                    >
                      Other Documnets File
                    </Typography>{" "}
                    <FileUploader
                      name="OtherFile"
                      label="Upload Your Other Document"
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                      handleChange={(e) => {
                        setFileTitle({ ...fileTitle, otherFile: e.name });
                        setUploadFiles({ ...uploadFiles, otherFile: e });
                      }}
                    />
                  </Grid>
                  <div className="fileTitle">
                    {fileTitle?.otherFile ? fileTitle?.otherFile : null}
                  </div>
                </Grid>
              </DialogContentText>
            </DialogContent>
            <div className="Dialog_Footer">
              <Button
                onClick={() => {
                  setFileTitle(null);
                  setOpenUploadFileBox(false);
                  setUploadFiles({});
                }}
                className="Dialog_Cancel"
              >
                Close
              </Button>
              <Button
                autoFocus
                onClick={() => UploadFilesFunction()}
                className="Dialog_Save"
              >
                Update
              </Button>
            </div>
          </div>
        </Dialog>
        {/* <Loader open={openLoader} /> */}
      </div>

      <React.Fragment>
        <Dialog
          open={isEditRejectPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="DrawerContainer">
            <Grid container className="DrawerHeader">
              <Grid item xs={6} sm={6}>
                <Typography>Rejected Policy Update</Typography>
              </Grid>
              <Grid item xs={6} sm={6} className="d-flex justify-content-end">
                <CloseIcon
                  onClick={() => setIsEditRejectPopup(false)}
                  sx={{
                    cursor: "pointer",
                    height: "18px",
                    width: "18px",
                    fontWeight: 600,
                  }}
                />
              </Grid>
            </Grid>
            <Stack sx={{ padding: "10px 20px 20px" }}>
              <Typography
                sx={{
                  fontSize: "12px",
                  mb: 1,
                  color: "black",
                  fontWeight: 400,
                  paddingBottom: "4px",
                }}
              >
                Policy Number
              </Typography>{" "}
              <TextField
                sx={{
                  fontSize: "12px",
                  color: "black",
                  fontWeight: 400,
                  paddingLeft: "0px !important",
                  paddingTop: "0px !important",
                }}
                className="textField w-100"
                placeholder="Enter Policy number"
                onChange={(e) => setRejectdPolicyNumber(e.target.value)}
              />
            </Stack>
            <div className="Dialog_Footer">
              <Button
                onClick={() => setIsEditRejectPopup(false)}
                className="Dialog_Cancel"
              >
                Close
              </Button>
              <Button
                autoFocus
                onClick={() => EditRejectedPolicyFunction()}
                className="Dialog_Save"
              >
                Update
              </Button>
            </div>
          </div>
        </Dialog>
      </React.Fragment>
      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
    </>
  );
};
export default PolicyList;
